export const env = {
  API_URL: process.env.REACT_APP_API_URL,
  TURNSTILE_URL: process.env.REACT_APP_TURNSTILE_URL,
  TURNSTILE_SITE_KEY: process.env.REACT_APP_TURNSTILE_SITE_KEY
} as const; 